export var fieldType = 'radioList';
